<template>
<div>
  <div @click="backHomePages" class="back_homepage"></div>
   <div class="p01_banner">
     <p class="p1 wow fadeInDown">「 自主可控平台化物联网控制系统 」</p>
     <div class="isline wow fadeInLeft"></div>
     <p class="p2 wow fadeInRight">信令类数据物联网化平台，彻底取代传统控制系统，消灭烟囱式结构，实现互联互通</p>
     <div class="isline wow fadeInLeft"></div>
     <p class="p3 wow fadeInUp">所谓数据汇聚，绝不仅在平台层面，这应该是多数互联网公司的认知盲点，将导致一个错误的架构并将整个项目引向失败。<br>实际上数据汇聚将至少发生在以下三个层面：首先在基础场景层面，与场景相关的数据首先汇聚至现场控制设备，其次在边缘侧，汇聚来自现场控制器数据，再次通过与需求相关的定义后，汇聚云端进行更深层次的挖掘利用，<br>三个层面的数据处理应该是互动协调的调度机制。这样才可以形成一个完整的基于物联网技术的、可不断迭代的智慧建筑/园区物联网管理平台。</p>
   </div>

  <div class="content2">
    <div style="position: relative;width: 100%;height: 11%">
      <div style="font-size: 2.1vh;position: absolute;left: 46%;top: 65%">北京安卯物联技术有限公司</div>
      <div class="home-logo" style="left: 42%;top: 70%"></div>
    </div>
    <div style="font-size: 1.5vh;width: 50%;margin-left: 25%;margin-top: 2%">北京安卯物联技术有限公司长期致力于智能控制产品、低压配电盘柜智能制造技术的设计、开发，旨在通过自主可控的技术、产品在智能建筑领域推广设备设施物联网化、低压配电设备智能制造、弱电工程工厂化等先进理念及技术。
      2018年，AIM成为腾讯微瓴重要合作伙伴，开发、生产可取代和超越传统楼宇自控系统、智能照明、门禁、安全系统的物联网智能控制产品，2019年参与“苏州腾讯微瓴数字建筑实验室”建设。
      AIM多年深耕智能建筑控制领域、智能建筑配电，具备涵盖机电设备控制、照明、门禁、消防、安防、低压配电等领域的门类齐全的物联网控制产品及解决方案。同时已开发完成智能低压盘柜加工机器人等智能化生产设备，在苏州设有物联网控制产品及低压盘柜智能生产线。AIM将成为具有集设计、开发、智能生产于一体的面向新时代智慧城市领域的专业公司。​</div>
    <div style="font-size: 2vh;margin-top: 3%">价值体现</div>
    <div style="font-size: 1.5vh;width: 50%;margin-left: 25%;margin-top: 2%">我们为客户带来从设计到运维阶段全生命周期的优势。
      物联网化解决方案可为建筑设施增加价值，满足客户需求并使其符合更高的能效标准。
      物联网技术使利用大数据、人工智能实时分析现场设备的有价值数据成为可能，客户可以使用统一监控平台密切监控大量设施、设备的性能。
      AIM“云就绪”物联网设备及智能制造技术使安装变得快捷方便。无论新建及改造项目，用户都可以快速可靠的完成智能化部署。</div>
    <div style="font-size: 2vh;margin-top: 3%">合作伙伴</div>
    <div style="font-size: 1.5vh;width: 50%;margin-left: 25%;margin-top: 2%">联想、泰豪、青云、微瓴、中电基、智业云、光环新网、中交智慧城市、珠海华发、中国港湾工程、中交信科、中建第二工程局、国能信控</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Demo',
  components: {

  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    backHomePages(){
      /*this.$router.push({name: 'homePage'})*/
    },
  }
}
</script>
<style scoped>
  .back_homepage{
    width: 25px;
    height: 20px;
    background-image: url("/static/img/homepage/home.png");
    position: absolute;
    background-size: 100% 100%;
    left: 95%;
    top: 4%;
    cursor: pointer;
  }
.p01_banner{
  width: 100%;
  height: 660px;
  background: url("/static/img/homepage/p01_banner.jpg") top center no-repeat;
  text-align: center;
  color: #FFFFFF;
}
.p01_banner .p1{ font-size:60px; line-height:200%; font-weight:bold; padding-top:200px; }
.p01_banner .p2{ font-size:30px; line-height:200%; }
.p01_banner .p3{ font-size:16px; line-height:150%; }
.p01_banner .isline{ width:100px; margin:20px auto; border-top:2px solid #fff; }
.content1{ width:100%; text-align:center; padding-top:50px; position:relative; }
.content1 .title1{ font-size:48px; color:#000; font-weight:bold; line-height:150%; }
.content1 .title1 span{ color:#ff3300; }
.content1 .title2{ font-size:24px; font-size:#333; }
.content1 .contentlist{ width:1080px; margin:0 auto; padding:50px 0; overflow:hidden; }
.content1 .contentlist li{ float:left; width:140px; margin:0 20px; }
.content1 .contentlist li .icon{ width:120px; height:120px; -moz-border-radius: 70px; -webkit-border-radius: 70px; border-radius:70px; background:#ff3300; border:10px solid #fff; line-height:120px; }
.content1 .contentlist li p{ font-size:14px; line-height:150%; color:#000; text-align:center; }
.content1 .contentlist li p strong{ display:block; font-size:16px; line-height:200%; }
.content1::before{
  content:'';
  position:absolute;
  top:265px;
  left:0;
  border-top:1px solid #ccc;
  width:100%;
  background:#333;
  z-index:-1;
}
.content2{ width:100%; height:980px; text-align:center; overflow:hidden; }
.content2 .con_tit_1{ font-size:48px; color:#ffcc00; font-weight:bold; line-height:200%; padding-top:50px; }
.content2 .con_tit_2{ font-size:30px; color:#dfdfdf; line-height:150%; }
.content2 .con_text{ width:1200px; margin:0 auto; }
  .home-logo{
    width: 70px;
    height: 20px;
    background-image: url("/static/img/AIM.png");
    background-size: 100% 100%;
    position: absolute;
  }
</style>




// WEBPACK FOOTER //
// src/pages/homePageAssembly/about.vue